import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
export const missionHeaderStyleMap = {
    draft: {
        color: themeColors.accent.blue.bold,
        backgroundColor: themeColors.accent.blue.subtlest,
    },
    closed: {
        color: themeColors.accent.grey.bold,
        backgroundColor: themeColors.accent.grey.subtlest,
    },
    mobilizing: {
        color: themeColors.accent.green.bold,
        backgroundColor: themeColors.accent.green.subtlest,
    },
    inProgress: {
        color: themeColors.accent.green.bold,
        backgroundColor: themeColors.accent.green.subtlest,
    },
    complete: {
        color: themeColors.accent.green.bold,
        backgroundColor: themeColors.accent.green.subtlest,
    },
};
